import clsx from 'clsx';
import React from 'react';

import EmailLeadCapture from '@components/EmailLeadCapture';
import { Env } from '@contexts/AppContext';
import { subscribe_path } from '@routes';
import { FormLocation, LeadTypes } from '@utils/enums';
import { getImgixSrc } from '@utils/images';

import styles from './styles.module.scss';

const Logos = [
  'Bain.png',
  'Spotify.png',
  'Goldman.png',
  'Upenn.png',
  'Meta.png',
  'Morgan.png',
  'Amazon.png',
  'Netflix.png',
  'Google.png',
  'Accenture.png',
  'Uber.png',
  'Stanford.png',
  'Columbia.png',
  'Harvard.png',
  'Microsoft.png',
];

const LayOut = ({ env }: { gdpr: boolean; env: Env }) => {
  return (
    <div className="org-signup container">
      <div className={clsx(styles.emailContainer, 'row')}>
        <div className={clsx(styles.emailWrapper, 'col-sm-12 col-md-9')}>
          <div className={clsx(styles.topRibbon)} />
          <div className={styles.header}>Sign up via your school or company</div>
          <div className={styles.subheader}>Your organization email</div>
          <EmailLeadCapture
            buttonText="Validate email"
            formLocation={FormLocation.OrgSignup}
            leadType={LeadTypes.OrgEmailDomain}
            redirectToOnSuccess={subscribe_path()}
            buttonClassName="get-started-button"
            inputClassName="get-started-input"
            gdprClassName="gdpr-toggle"
          />
        </div>
      </div>
      <div className={clsx(styles.logosContainer)}>
        {Logos.map((imgPath) => (
          <div key={imgPath} className={styles.imageContainer}>
            <img
              className={styles.image}
              src={getImgixSrc({
                path: `logo-image-url/${imgPath}`,
                isEnvDependent: true,
                envContext: env,
              })}
              alt={`${imgPath.replace('.png', '')} icon`}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default LayOut;
